import * as React from "react";
import {Col, Row} from "antd";

interface StatisticsLayoutProps {
  left: React.ReactNode;
  right: React.ReactNode;
}

export default class StatisticsLayout extends React.Component<StatisticsLayoutProps, {}> {

  public render(): React.ReactNode {
    const {left, right} = this.props;
    return (
      <Row type="flex" align="top">
        <Col xs={24} sm={12}>{left}</Col>
        <Col xs={24} sm={12}>{right}</Col>
      </Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/statistics/utils/StatisticsLayout.tsx